//TOGGLE ALT

import React from 'react'
import '../styles/header.css'
import Header from './Header'
import SubHeader from './SubHeader'
import IconHeader from './IconHeader'

class ToggleAlt extends React.Component {
    
    constructor(props) {
        super(props)
        this.toggle = this.toggle.bind(this)
        this.toggleContent = this.toggleContent.bind(this)
        this.state = {
            showContent: false
        }
    }
    
    toggle(event) {
        event.preventDefault()
        alert('clicked!')
    } 
    
    toggleContent(event) {
        event.preventDefault()
        this.setState({
            showContent: !this.state.showContent
        })
    }
    
    render() {
        
        const {showContent} = this.state;   
        
        return(
    
            <div class={this.props.divClass}>
                
                <div class="row">
                    
                    <div class="colTable">
                        
                        <div class="col-4 iconBannerCol inline tableCell">
                            
                            <img class="sizeAlt" src={this.props.icon} alt=""/>
                            <p class="iconTitle">{this.props.name}</p>
                            
                        </div>
                        
                        <div class="col-8 inline tableCell">
                        
                            <SubHeader styles="header leftHeader clickableHeader pointer paddingLeft" title={this.props.name}/>
            
                            <p class="standardText">{this.props.preview}</p>
            
                            <div dangerouslySetInnerHTML={{ __html: this.props.toggle}} />
                            
                            
                            
                            
                        </div>
                        
                    </div>
                    
                    <div class="container containerWidth">
                        
                        <div>

                            {showContent === true ? <div>

                                <div>

                                    <div dangerouslySetInnerHTML={{ __html: this.props.data }} />

                                </div>

                            </div> : ""} 
                            
                        </div>
                        
                    </div>
                    
                </div>

            </div>
        );
        
    }
}
    
export default ToggleAlt